if (!customElements.get('country-switcher')) {
  customElements.define(
    'country-switcher',
    class CountrySwitcher extends HTMLElement {
      constructor() {
        super();

        this.config = {
          geoText: '[data-geo-text]',
          geoRedirect: '[data-geo-redirect]',
          geoContinue: '[data-geo-continue]',
          geoCountries: '[data-geo-countries]',
          geoCountry: '[data-geo-country]',
          geoLanguages: '[data-geo-languages]',
          geoLanguage: '[data-geo-language]',
          geoCountryInput: '[data-geo-country-input]',
          geoLanguageInput: '[data-geo-language-input]',
          apacSubdomain: 'apac',
          bermudaIsoCode: 'BM'
        };

        this.useSuggestion = false;
        this.countries = Woolman.geoInfo.countryJson;
        this.geoText = this.querySelector(this.config.geoText);
        this.geoRedirect = this.querySelector(this.config.geoRedirect);
        this.geoContinue = this.querySelector(this.config.geoContinue);
        this.geoCountries = this.querySelector(this.config.geoCountries);
        this.geoCountry = this.querySelector(this.config.geoCountry);
        this.geoLanguages = this.querySelector(this.config.geoLanguages);
        this.geoLanguage = this.querySelector(this.config.geoLanguage);
        this.geoCountryInput = this.querySelector(this.config.geoCountryInput);
        this.geoLanguageInput = this.querySelector(this.config.geoLanguageInput);

        this.formatSwitcher();

        this.geoCountries.addEventListener('change', function(event) {
          this.popolateLanguagesList(event.detail.element.dataset.value, true);
          this.setDefaultLanguageName(event.detail.element.dataset.value, true);
        }.bind(this));

        this.geoRedirect.addEventListener('click', function() {
          this.handleRedirection();
        }.bind(this));
      }

      popolateCountriesList () {
        let countryArray = [...this.countries];

        countryArray.sort((a, b) => a.name.localeCompare(b.name));

        let html = '';

        countryArray.map((country) => {
          html +=`<li class="disclosure__item" role="option" ${((this.useSuggestion && country.isocode == this.country) || Shopify.country == country.isocode) ? 'aria-selected="true"' : 'aria-selected="false"'}>
            <button class="disclosure__link ${((this.useSuggestion && country.isocode == this.country) || (!this.useSuggestion && Shopify.country == country.isocode)) ? 'disclosure__link--active' : ''}" ${((this.useSuggestion && country.isocode == this.country) || Shopify.country == country.isocode) ? 'aria-current="true"' : ''} data-value="${country.isocode}">
              ${country.name}
            </button>
          </li>`
        });

        this.geoCountries.querySelector('.disclosure__list').innerHTML = html
      }

      popolateLanguagesList (countryIsocode, fromEvent = false) {
        let countryArray = [...this.countries];
        const selectedCountry = countryArray.find(country => country.isocode == countryIsocode);

        if (!selectedCountry || selectedCountry.use_old_domain) {
          this.geoLanguages.setAttribute('aria-hidden', true);
          this.geoLanguages.setAttribute('hidden', true);

          return;
        }

        this.geoLanguages.setAttribute('aria-hidden', false);
        this.geoLanguages.removeAttribute('hidden');

        let html = '';

        selectedCountry.market.languages.map((language) => {
          const languageReference = Woolman.geoInfo.languages.find(el => el.key == language.key);

          html +=`<li tabindex="-1" class="disclosure__item">
            <button class="disclosure__link ${((this.useSuggestion || fromEvent) && language.primary) || (!this.useSuggestion && Shopify.locale == languageReference.isocode && selectedCountry.isocode == Shopify.country) ? 'disclosure__link--active' : ''}" ${language.primary ? 'aria-current="true"' : ''} data-value="${language.key}">
              ${languageReference.native}
            </button>
          </li>`
        });

        if (selectedCountry.market.languages.length < 2) {
          this.geoLanguages.classList.add('disabled');
        } else {
          this.geoLanguages.classList.remove('disabled');
        }

        this.geoLanguages.querySelector('.disclosure__list').innerHTML = html;
      }

      setSuggestedCountry (country) {
        if (country) {
          this.useSuggestion = true;
          this.country = country;

          return;
        }

        this.useSuggestion = false;
        this.country = null;
      }

      setDefaultCountryName () {
        const country = this.useSuggestion ? this.country : Shopify.country;

        this.geoCountry.innerHTML = this.countries.find(o => o.isocode == country)?.name;
      }

      setDefaultLanguageName (isocode = this.country || Shopify.country, fromEvent = false) {
        if (this.useSuggestion || fromEvent) {
          const languageKey = this.countries.find(o => o.isocode == isocode)?.market.languages?.find(o => o.primary)?.key;
          this.geoLanguage.innerHTML = Woolman.geoInfo.languages.find(el => el.key == languageKey)?.native;

          return;
        }

        this.geoLanguage.innerHTML = Woolman.geoInfo.languages.find(el => el.isocode == Shopify.locale)?.native;
      }

      formatSwitcher () {
        this.popolateCountriesList();
        this.setDefaultCountryName();
        this.popolateLanguagesList(this.country || Shopify.country);
        this.setDefaultLanguageName();

        return true;
      }

      formatRedirectionUrl(languageKey, selectedCountry) {
        if (selectedCountry.use_old_domain) {
          const domain = Woolman.geoInfo.oldDomains.find(el => selectedCountry.old_domain == el.key)?.value;

          return `https://${domain}`;
        }

        const domain = Woolman.geoInfo.domains.find((el) => selectedCountry.market.domain == el.key)?.value;
        const languageSubfolder = selectedCountry.market.languages.find((l) => l.key == languageKey).subfolder;

        let UTMParameters = Woolman.Marketing.getUTMParametersFromURL();
        if (Object.keys(UTMParameters).length === 0) {
          const spUtm = window.sessionStorage.getItem('sp_utm');
          if (spUtm) {
            UTMParameters = JSON.parse(spUtm);
          }
        }
        const spReferrer = window.sessionStorage.getItem('sp_ref');
        if (spReferrer) {
          UTMParameters.sp_ref = spReferrer
        }

        const marketPath = Shopify.routes.root.replace(/\/$/, '');
        const pathWithoutMarket = window.location.pathname.replace(marketPath, '') || '/';

        return `https://${domain}${languageSubfolder != '' ? '/': ''}${languageSubfolder}${pathWithoutMarket}?redirection=true&country=${selectedCountry.isocode}${Object.keys(UTMParameters).length > 0 ? '&'.concat(new URLSearchParams(UTMParameters).toString()) : ''}`;
      }

      handleRedirection() {
        const selectedCountryIsocode = this.geoCountries.querySelector('.disclosure__link--active').dataset.value;
        const selectedLanguageKey = this.geoLanguages.querySelector('.disclosure__link--active')?.dataset.value;
        const selectedLanguageIsocode = Woolman.geoInfo.languages.find(el => selectedLanguageKey == el.key)?.isocode;
        const selectedCountry = this.countries.find(c => c.isocode == selectedCountryIsocode);

        const subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;

        if (subdomain == this.config.apacSubdomain && selectedCountryIsocode == this.config.bermudaIsoCode) {
          window.location.href = this.formatRedirectionUrl(selectedLanguageKey, selectedCountry);

          return;
        }

        if (Woolman.geoInfo.availableCountriesIso.includes(selectedCountryIsocode) && !selectedCountry.use_old_domain) {
          const form = this.querySelector('form');

          form.querySelector('[data-geo-country-input]').value = selectedCountryIsocode;
          form.querySelector('[data-geo-language-input]').value = selectedLanguageIsocode;

          if (form) {
            form.dispatchEvent(new Event('submit'));
            form.submit();
          }

          return;
        }

        window.location.href = this.formatRedirectionUrl(selectedLanguageKey, selectedCountry);
      }
    }
  );
}
